/** @jsxImportSource solid-js */
import { classed } from "#palette/style/index.solid";

export const TooltipBase = classed.div`max-w-xs z-50 absolute shadow-lg hidden group-hover/tooltip:block bg-brand-700 text-white my-3 px-3 py-[6px] text-sm mx-auto w-max rounded`;
export const BottomRightTooltip = classed(
  TooltipBase,
)`right-0 before:w-4 before:h-4 before:rotate-45 before:bg-brand-700 before:absolute before:z-[-1] before:-top-1 before:right-0 before:mx-5 before:content-empty`;
